import { memo } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import { BlogCard } from "@/components/BlogParts";
import { BLOG_ARTICLES } from "@/blog/articles";

const renderHomeBlogCard = (article) => <BlogCard key={article.slug} article={article} />;

export const BlogSection = memo(() => (
  <section className="section-padding bg-white" data-testid="home-blog-section">
    <div className="container-custom max-w-6xl">
      <div className="text-center mb-12">
        <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">Blog & Conseils</Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Articles récents</h2>
        <p className="text-lg text-slate-600">Conseils, guides et astuces de nos experts Apple à Niort</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {BLOG_ARTICLES.slice(0, 3).map(renderHomeBlogCard)}
      </div>

      <div className="text-center mt-10">
        <Link to="/blog" data-testid="home-blog-cta">
          <Button size="lg" variant="outline" className="gap-2">
            Voir tous les articles
            <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
));

BlogSection.displayName = "BlogSection";
